module.exports = __webpack_public_path__ + "img/law_y_sample.9e2930bd.png";